// https://github.com/paulmillr/es6-shim
// http://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.isinteger
var isFinite = require("is-finite");
module.exports = Number.isInteger || function(val) {
  return typeof val === "number" &&
    isFinite(val) &&
    Math.floor(val) === val;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/is-integer/index.js
 ** module id = 42
 ** module chunks = 1
 **/